<template>
  <div class="main-content-wrapper reward matches">
    <Menu></Menu>
    <h1 class="game-title" v-if="gameKey">Edit Game</h1><h1 class="game-title" v-else>Create Game</h1>
    <span class="subcontent">You can edit the game anytime before it starts.</span>
    <el-input class="game-input" placeholder="Name of the game" v-model="gameInfo.name" clearable></el-input>
    <div class="contest-box">
      <h4 class="add-macthes-title">Add your Matches</h4>
      <div class="contest-box-inner">
        <div class="add-match-box">
          <p>Enter Match Key</p>
          <div class="tooltip"><img class="right-part" src="@/assets/imgs/question-mark.svg">
            <span class="tooltiptext">You can get the match either via the <a target="_blank" href="https://blackbird.litzscore.com">Cricket API Website</a> or via the <a target="_blank" href="https://www.cricketapi.com/docs/Core-API/Schedule-API/">Schedule API</a></span>
          </div>
         
          <el-input placeholder="Ex: iplt20_2020_g1" v-model="matchKey" clearable></el-input>
          <div class="add-matches">
            <button class="confirm-btn add-match" @click="addMatches">Add Match</button>
          </div>
        </div>
      </div>
    </div>
    <div class="matches-info" v-if="connectedMatches.length > 0">
      <label class="box-space">Connected Matches</label>
       <div class="contest-box" v-for="(match,index) in connectedMatches" :key="match.key">
        <div class="contest-box-inner bottom-space">
          <div class="left-part">
            <div>
              <div class="matches-dec">
                <span></span>
                <span class="small"></span>
                <span class="small"></span>
                <span class="sec"></span>
              </div>
              <div>
                <div class="match-name">{{match.teama_name}}</div>
                <div class="match-name  sec">{{match.teamb_name}}</div>
              </div>
            </div>
          </div>
          <div class="right-part">
            <div class="match-format"></div>
            <div class="match-format">{{match.subtitle}}</div>
          </div>
          <div>
          <div class="left-part">
            <span class="start-date">Starts: {{match.start_at | relativeShortDateTime}}</span>
          </div>
          <div class="right-part">
            <span class="remove-btn" @click="removeMatch(index)">REMOVE</span>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="img-box">
        <img src="@/assets/imgs/description.svg">
      </div>
      <div class="content">
        <h5>Notes</h5>
        <p v-if="gameInfo.desc">{{gameInfo.desc}}</p>
        <p v-else>Add notes about the game this will be visible in the game.</p>
        <p>
          <button class="add-link" v-if="gameInfo.desc" @click="showNotes = true">Edit</button>
          <button class="add-link" v-else @click="showNotes = true">Add</button>
        </p>
        <AddTextPopup :payload="gameInfo" :property="'desc'" @onClose="onClose" :show="showNotes"></AddTextPopup>
      </div>
    </div>
    <div class="flex-box" v-if="type != 'edit'">
      <div class="flex-item first" >
        <button class="skip-btn" @click="goBack">Skip</button>
      </div>
      <div class="flex-item second">
        <button class="create-btn" @click="createGame()">Save</button>
      </div>
    </div>
    <div v-else class="flex-box">
      <div class="flex-item first" >
        <button class="skip-btn" @click="goBack">Cancel</button>
      </div>
      <div class="flex-item second">
        <button class="create-btn" @click="createGame()">Save</button>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { Contest } from '@/models/fantasyconsole/contest'
import { Game } from '@/models/fantasyconsole/game'
import AddTextPopup from '@/components/fantasyconsole/AddTextPopup'

export default {
  components: {
    AddTextPopup
  },
  props: {
    contest: {
      type: Object,
      defult: null
    },
    type: null
  },

  data () {
    return {
      ruleManager: null,
      state: DataState.newLoading(),
      matchKey: null,
      gameInfo: new Game(),
      gameKey: this.$route.params.gameKey,
      game: {},
      contestKey: null,
      contestInfo: {},
      showNotes: false,
      connectedMatches: []
    }
  },

  watch: {
    '$route' (to, from) {
      if (to.params.gameKey !== from.params.gameKey) {
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },

  mounted () {
    if (this.$route.params.key) {
      this.contestKey = this.$route.params.key
      this.getContestInfo(this.contestKey)
    }
    if (this.$route.params.gameKey) {
      this.onViewOpenned()
    }
  },

  methods: {
    getContestInfo (key) {
      if (key) {
        Contest.getContest(key).then((resp) => {
          this.contestInfo = resp
        }).catch((error) => {
          this.state.changeToError(error)
        })
      }
    },
    addMatches () {
      if (this.matchKey) {
        Game.validateMatch(this.contestInfo.sport, this.contestKey, this.matchKey).then(resp => {
          if (resp.error) {
            this.$notify({
              title: 'Error',
              message: resp.error.msg,
              type: 'error'
            })
          } else {
            this.connectedMatches.push(resp.data.matches)
            if (this.connectedMatches.length > 0) {
              this.gameInfo.match_keys.push(this.matchKey)
            }
            this.matchKey = ''
            this.state.changeToLoaded()
          }
        }).catch((error) => {
          console.log('error', error)
          this.$notify({
            title: 'Error',
            message: 'Something went wrong!..',
            type: 'error'
          })
          this.state.changeToError(error)
        })
      } else {
        this.$notify({
          title: 'Error',
          message: 'Please enter match key..!',
          type: 'error'
        })
      }
    },
    createGame () {
      this.gameInfo.contest_key = this.contestKey
      if (this.gameInfo.key) {
        this.editGame()
      } else {
        if (this.connectedMatches.length > 0) {
          this.gameInfo.match_keys = []
          for (let match of this.connectedMatches) {
            const found = this.gameInfo.match_keys.some(e1 => e1 === match.key)
            if (!found) {
              this.gameInfo.match_keys.push(match.key)
            }
          }
        }
        if (this.gameInfo.match_keys.length > 0) {
          Game.createGame(this.gameInfo).then((resp) => {
            this.game = resp
            this.$notify({
              title: 'Success',
              message: 'Game created successfully',
              type: 'success'
            })
            this.state.changeToLoaded()
            this.$emit('saveGame')
          }).catch((error) => {
            this.state.changeToError(error)
            if (this.state.msg.response.data.error) {
              this.$notify({
                title: 'Error',
                message: this.state.msg.response.data.error.msg,
                type: 'error'
              })
            }
          })
        } else {
          this.$notify({
            message: 'Please add atleast one match',
            type: 'warning'
          })
        }
      }
    },
    editGame () {
      if (this.connectedMatches.length > 0) {
        this.gameInfo.match_keys = []
        for (let match of this.connectedMatches) {
          const found = this.gameInfo.match_keys.some(e1 => e1 === match.key)
          if (!found) {
            this.gameInfo.match_keys.push(match.key)
          }
        }
        this.gameInfo = new Game(this.gameInfo.key, this.gameInfo.contest_key, null, this.gameInfo.name, this.gameInfo.desc, this.gameInfo.match_keys)
      } else {
        this.gameInfo.match_keys = []
        this.gameInfo = new Game(this.gameInfo.key, this.gameInfo.contest_key, null, this.gameInfo.name, this.gameInfo.desc, this.gameInfo.match_keys)
      }
      if (this.gameInfo.match_keys.length > 0) {
        Game.editGame(this.gameInfo).then((resp) => {
          if (resp.error) {
            this.$notify({
              title: 'Error',
              message: resp.error.msg,
              type: 'error'
            })
          } else {
            this.game = resp
            this.$notify({
              title: 'Success',
              message: 'Game edited successfully',
              type: 'success'
            })
            this.state.changeToLoaded()
            this.$router.push({ name: 'FCEditContest', params: { 'key': this.contestKey } })
          }
        }).catch((error) => {
          this.state.changeToError(error)
          if (this.state.msg.response.data.error) {
            this.$notify({
              title: 'Error',
              message: this.state.msg.response.data.error.msg,
              type: 'error'
            })
          }
        })
      } else {
        this.$notify({
          message: 'Please add atleast one match',
          type: 'warning'
        })
      }
    },
    onViewOpenned () {
      Game.fetchGame(this.gameKey).then((resp) => {
        this.gameInfo = resp
        this.connectedMatches = []
        for (var match of this.gameInfo.matches) {
          this.connectedMatches.push(match.match)
        }
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
    onClose (payload, show) {
      this.showNotes = show
    },
    removeMatch (index) {
      this.connectedMatches.splice(index, 1)
      this.gameInfo.match_keys.splice(index, 1)
    },
    goBack () {
      if (this.$route.name == 'FCEditContest') {
        this.$router.push({ name: 'FCHome' })
      } else {
        this.$router.push({ name: 'FCEditContest', params: { key: this.contestKey } })
      }
    }
  }
}
</script>
